import { merchantApi } from '@/config/axios'

/** 与 TradeInvoiceStatusEnum 对齐 */
export const INVOICE_STATUS = {
  PENDING: 0,
  ISSUED: 10,
  REJECTED: 20,
  CANCELLED: 30
} as const

export const getInvoicePage = (params: any) =>
  merchantApi.get({ url: '/merchant-api/trade/invoice/page', params })

export const getInvoice = (id: number) =>
  merchantApi.get({ url: '/merchant-api/trade/invoice/get?id=' + id })

export const getInvoiceByOrder = (orderId: number) =>
  merchantApi.get({ url: '/merchant-api/trade/invoice/get-by-order?orderId=' + orderId })

export const issueInvoice = (data: {
  id: number
  invoiceNo?: string
  invoiceUrl?: string
  adminRemark?: string
}) => merchantApi.put({ url: '/merchant-api/trade/invoice/issue', data })

export const rejectInvoice = (data: { id: number; rejectReason: string }) =>
  merchantApi.put({ url: '/merchant-api/trade/invoice/reject', data })
